"use client";

import { c as _c } from "react/compiler-runtime";
import { FastFillingEvent } from "../common/fast-filling-event";
import { DownloadBrochureCard } from "../common/download-brochure-card";
import { HaveMoreQuestionCard } from "../common/have-more-question-card";
import NonCertificationBannerCard from "../common/non-certification-banner-card";
type CourseAsideProps = {
  data: {
    event: ServiceEvent;
    serviceId: string;
    certificationImage: string | null;
  };
};
export function CourseAside(t0) {
  const $ = _c(13);
  const {
    data
  } = t0;
  const t1 = data?.event;
  let t2;
  if ($[0] !== t1) {
    t2 = <FastFillingEvent data={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = data?.serviceId;
  let t4;
  if ($[2] !== t3) {
    t4 = <DownloadBrochureCard serviceId={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = data?.serviceId;
  let t6;
  if ($[4] !== t5) {
    t6 = <HaveMoreQuestionCard serviceId={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== data.certificationImage) {
    t7 = data.certificationImage && <NonCertificationBannerCard certificationImage={data?.certificationImage} />;
    $[6] = data.certificationImage;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className="space-y-4">{t2}{t4}{t6}{t7}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}